import type { ReactNode } from "react"

import { useFeatureFlag } from "@/hooks/use-feature-flag"
import type { FeatureFlags } from "@/types"

interface FeatureProps {
  name: keyof FeatureFlags
  children: ReactNode
  fallback?: ReactNode
}

export function Feature({ name, children, fallback = null }: FeatureProps) {
  return useFeatureFlag(name) ? <>{children}</> : <>{fallback}</>
}
